import { stringify } from 'query-string'
import { useHistory, useLocation } from 'react-router'

export const useRedirectWithBreadcrumb = () => {
  const location = useLocation()
  const history = useHistory()

  const redirect = (pathname: string, shouldLeaveBradcrumb = true) => {
    const { pathname: currPath, search: currSearch } = location
    if (!shouldLeaveBradcrumb) {
      history.push({ pathname, search: currSearch })

      return
    }

    history.push({
      pathname,
      search: stringify({
        from: `${currPath}${currSearch}`,
      }),
    })
  }

  return redirect
}
